import api from './api.js'
export default {

  timeExistFormat: function(date, format) {
    if (date == 0 || date == null || date == '') {
      return '-'
    } else {
      return this.timeFormat(new Date(date), format)
    }
  },

  timestampToTime: function(data) {
    return new Date(data)
  },

  timeFormat: function(date, format) {
    var formateArr = ['yyyy', 'MM', 'dd', 'hh', 'mm', 'ss']
    var returnArr = []
    returnArr.push(date.getFullYear())
    returnArr.push(date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1))
    returnArr.push(date.getDate() >= 10 ? date.getDate() : '0' + date.getDate())
    returnArr.push(date.getHours())
    returnArr.push(date.getMinutes())
    returnArr.push(date.getSeconds())
    for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
    }
    return format
  },

  status: function(status) {
    switch (status) {
      case 0:
        return '暂存'
      case 1:
        return '待审批'
      case 2:
        return '审批未通过'
      case 3:
        return '审批通过'
      case 4:
        return '已借用'
      case 5:
        return '已归还'
      case 6:
        return '公司审批通过'
      default:
        return ''
    }
  },

  lendApplyStatus: function(status) {
    switch (status) {
      case 1:
        return '待审核'
      case 10:
        return '进行中'
      case 20:
        return '已通过'
      case 30:
        return '未通过'
      case 40:
        return '已领款'
      case 50:
        return '已核销'
      default:
        return ''
    }
  },
  travelApplyStatus: function(status) {
    switch (status) {
      case 1:
        return '待审核'
      case 10:
        return '进行中'
      case 20:
        return '已通过'
      case 30:
        return '未通过'
      case 40:
        return '已领款'
      case 50:
        return '已核销'
      default:
        return ''
    }
  },
  signInType: function(type) {
    switch (type) {
      case 0:
        return '签到'
      case 1:
        return '签退'
      case 2:
        return '外勤'
    }
  },

  payApplyType: function(type) {
    switch (type) {
      case 1:
        return '待审核'
      case 10:
        return '进行中'
      case 20:
        return '已通过'
      case 30:
        return '未通过'
      case 40:
        return '收到发票'
      case 50:
        return '已付款'
    }
  },

  licenseStatus: function(status) {
    switch (status) {
      case 1:
        return '在库'
      case 2:
        return '借出'
      case 3:
        return '已转出'
      default:
        return ''
    }
  },

  convertTree: function(tree) {
    const result = []
    tree.forEach((item) => {
      const value = item.id + ''
      const label = item.title
      let children = item.children
      if (item.children && item.children.length > 0) {
        children = this.convertTree(children)
      }
      result.push({
        value,
        label,
        children
      })
    })

    return result
  },

  businessTripStatus: function(status) {
    switch (status) {
      case 1:
        return '待审批'
      case 10:
        return '审批进行中'
      case 20:
        return '审批已通过'
      case 30:
        return '审批未通过'
      case 40:
        return '撤回'
      case 50:
        return '已领款'
      default:
        return '-'
    }
  },
  payStatus: function(status) {
    switch (status) {
      case 1:
        return '待审批'
      case 10:
        return '审批进行中'
      case 20:
        return '审批已通过'
      case 30:
        return '审批未通过'
      case 40:
        return '已付款'
      case 50:
        return '已提交发票'
      case 55:
        return '发票已确认'
      case 60:
        return '已撤回'
      default:
        return '-'
    }
  },
  withdrowStatus: function(status) {
    switch (status) {
      case 1:
        return '待审批'
      case 10:
        return '审批进行中'
      case 20:
        return '审批已通过'
      case 30:
        return '审批未通过'
      case 40:
        return '撤回'
      default:
        return '-'
    }
  },
  travellingExpense(status) {
    switch (status) {
      case 1:
        return '待审批'
      case 10:
        return '审批进行中'
      case 20:
        return '审批已通过'
      case 30:
        return '审批未通过'
      case 40:
        return '已领款'
      case 50:
        return '已撤回'
      default:
        return '-'
    }
  },
  getProjectType() {
    var roles = sessionStorage.getItem('roles')
    return roles.includes('tender') ? 1 : 2
  },
  getProjectUrl() {
    var roles = sessionStorage.getItem('roles')
    return roles.includes('tender') ? api.tenderBizProjectApi + '/search' : api.bizProjectApi + '/1/100'
  },
  getStringName(name) {
    return name || '-'
  },
  fileTypes(name) {
    var type = {
      '001': '.docx,.xlsx,.pdf,.jpg,.xls,.doc',
      '002': '.docx,.xlsx,.pdf,.jpg,.xls,.doc',
      '003': '.docx,.xlsx,.pdf,.jpg,.xls,.doc',
      '004': '.docx,.xlsx,.pdf,.jpg,.zip,.xls,.doc',
      '005': '.pdf,.docx,.xlsx,.xls,.doc',
      '006': '.pdf',
      '007': '.docx,.xlsx,.xls,.doc',
      '008': '.docx,.xlsx,.jpg,.xls,.doc,.pdf',
      '009': '.docx,.doc,.pdf',
      '010': '.docx,.xlsx,.pdf,.zip,.xls,.doc,.pdf',
      '011': '.docx,.xlsx,.pdf,.zip,.xls,.doc,.pdf',
      '012': '.docx,.xlsx,.pdf,.zip,.xls,.doc',
      '013': '.docx,.xlsx,.pdf,.zip,.xls,.doc,.pdf',
      '014': '.docx,.xlsx,.pdf,.xls,.doc,.pdf',
      '015': '.pdf',
      '016': '.pdf',
      '017': '.pdf',
      '018': '.pdf,.jpg,.jpeg,.png,.bmp',
      '019': '.pdf,.jpg,.jpeg,.png,.bmp',
      '020': '.pdf',
      '021': '.jpg,.jpeg,.png,.bmp,.pdf',
      '022': '.pdf',
      '023': '.pdf',
      '024': '.pdf,.docx,.xlsx,.zip,.jpg,.xls,.doc',
      '025': '.rar,.zip',
      '026': '.docx,.doc',
      '027': '.pdf',
      '028': '.pdf',
      '030': '.pdf'
    }
    return type[name] ? type[name] : '.docx,.xlsx,.pdf,.jpg,.xls,.doc'
  }
}



// WEBPACK FOOTER //
// ./src/lib/dataUtils.js